const transitionDurationMS = 400;
const Selector = {
  IMG_PRELOADER: '.img-preloader',
  IMG_PRELOADER__ORIGINAL: '.img-preloader__original'
};

const CSS = {
  NO_TRANSITION: 'no-transition',
  LOADED: 'loaded'
};

const loadImageAsync = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      resolve(image);
    };

    image.onerror = () => {
      reject(new Error('Could not load image at: ' + url));
    };

    image.src = url;
  });
};

const initPreloadImage = ($) => {
  $(Selector.IMG_PRELOADER).each(async function (index) {
    const target = $(this);
    const data = target.data('img-original-url');

    if (data) {
      await loadImageAsync(data);

      const original = target.find(Selector.IMG_PRELOADER__ORIGINAL);
      const useTransition = !original.hasClass(CSS.NO_TRANSITION);

      original.css({
        'background-image': `url("${data}")`,
        'transition-delay': `${useTransition ? transitionDurationMS / 2 * index : transitionDurationMS}ms`
      });
      original.addClass(CSS.LOADED);
    }
  });
};

export default function preloadImage(window, $, async) {
  if (async) {
    initPreloadImage($);
  } else {
    $(window).load(() => {
      initPreloadImage($);
    });
  }
};



// WEBPACK FOOTER //
// ./_common/scripts/utils/preload-image.js